@if (goBackTranslationKey$ | async; as goBackTranslationKey) {
  <p
    (click)="goToPreviousPageOrClose()"
    class="back-nav">
    <cx-icon [type]="iconTypes.ARROW_EXPAND_LEFT"></cx-icon>
    {{ goBackTranslationKey | cxTranslate }}
  </p>
}

@if (mainImage$ | async; as main) {
  @if (productCampaign$ | async; as productCampaign) {
    <app-product-badge [content]="productCampaign.text"
      [style.backgroundColor]="productCampaign?.backgroundColor"
      [style.color]="productCampaign?.textColor"
    class="product-images-product-badge"></app-product-badge>
  }
  @if (zoomedImageurl) {
    <lib-ngx-image-zoom
      [thumbImage]=zoomedImageurl
      [fullImage]=zoomedImageurl
      [magnification]="2"
      [enableScrollZoom]="false"
      [scrollStepSize]="0.1"
      [enableLens]="false"
      [zoomMode]="isTabletMode? 'toggle' :'hover'"
      [lensWidth]="200"
      [lensHeight]="200"
    ></lib-ngx-image-zoom>
  } @else {
    <cx-media [container]="main"></cx-media>
  }
}

@if (thumbs$ | async; as thumbs) {
  @if (thumbs.length) {
    <cx-carousel
      class="thumbs"
      [items]="thumbs"
      itemWidth="120px"
      [hideIndicators]="false"
      [template]="thumb"
    ></cx-carousel>
  }
}

<ng-template #thumb let-item="item">
  <cx-media
    [container]="item.container"
    tabindex="0"
    (focus)="openImage(item.container)"
    [class.is-active]="isActive(item.container) | async"
    format="product"
    >
  </cx-media>
</ng-template>
